import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';

class CartaPorteAutotransporteIdentificacionVehicularForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isTouched: true,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const ConfigAutotransporte = CartaPorteCatalogoManager.get('c_cp_config_autotransporte');

    let catalogos = {};

    catalogos.ConfigAutotransporte = this.getCatalogo(ConfigAutotransporte);

    this.setState({
      catalogos,
    });
  }

  rules(data) {
    const isTouched = this.state.isTouched;

    const ConfigVehicular = ['string'];
    const PlacaVM = ['string', 'regex:/^[^(?!.*s)-]{5,7}$/'];
    const AnioModeloVM = ['integer', 'regex:/^(19[0-9]{2}|20[0-9]{2})$/'];

    return {
      ConfigVehicular: isTouched ? ['required'].concat(ConfigVehicular) : ConfigVehicular,
      PlacaVM: isTouched ? ['required'].concat(PlacaVM) : PlacaVM,
      AnioModeloVM: isTouched ? ['required'].concat(AnioModeloVM) : AnioModeloVM,
      PesoBrutoVehicular: ['required', 'min:0.01', 'decimal:2'],
    };
  }

  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(
        values.map((item) => {
          return {
            label: item.descripcion,
            value: item.clave,
          };
        }),
        'label'
      );

      return [
        {
          label: 'Selecciona',
          value: '',
        },
      ].concat(sorted);
    }
  };

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    this.notifyFormDataChange(data);
  };

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      isValid: validator.passes(),
    });

    this.props.onFormDataChange({
      data,
      isValid: validator.passes(),
    });
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  render() {
    const { data } = this.props;

    const rules = this.rules(data);

    const { catalogos = {} } = this.state;

    return (
      <>
        <div>
          <strong>Identificacion Vehicular</strong>
        </div>

        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Configuración Vehicular"
              name="ConfigVehicular"
              placeholder=""
              help=""
              rules={rules.ConfigVehicular}
              value={data.ConfigVehicular}
              options={catalogos.ConfigAutotransporte}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Placa Vehículo Motor"
              name="PlacaVM"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={rules.PlacaVM}
              value={data.PlacaVM}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Año Modelo Vehículo Motor"
              name="AnioModeloVM"
              placeholder=""
              help=""
              rules={rules.AnioModeloVM}
              value={data.AnioModeloVM}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Peso Bruto Vehicular"
              name="PesoBrutoVehicular"
              placeholder=""
              help=""
              rules={rules.PesoBrutoVehicular}
              value={data.PesoBrutoVehicular}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default CartaPorteAutotransporteIdentificacionVehicularForm;
